// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__O4UEn","errorBadge":"styles_errorBadge__r_Gpr","title":"styles_title__p_DXz"};